export const paymentMethods = ['PAYMENT_IN_ADVANCE'];

export interface ModifyAssetPaymentParams {
    orderId: string;
    orderNoSource: string;
    paymentDate: string;
}
